var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"#fff"}},[_vm._v("\n  自定义组件 demo 页面\n")])}
var staticRenderFns = []

export { render, staticRenderFns }